package org.mkui.colormap

enum class Assignments {
    STATIC, DYNAMIC
}